<template>
  <div class="page">
    <div class="header">
      <div class="left"><img :src="qyxx.logo" />{{qyxx.companyName}}</div>
      <div class="nav">
        <li v-for="(item, index) in navlist" :key="index" :class="item.indexData == navid ? 'active' : ''" @click="routerPath(index,item.path)">
          {{ item.name }}
        </li>
      </div>

      <div class="right"><p>{{dateTime.split(' ')[0]}}</p><p>{{dateTime.split(' ')[1]}}</p>星期{{weeks[week-1]}}</div>

      <i @click="loginOut" class="el-icon-switch-button" style="font-size: 1.5rem;
        position: absolute;
        right: 5rem;
        cursor:pointer;
        top: 1.8rem;"></i>

      <div class="canvars">
        <div class="title">{{qyxx.sysName}}</div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import api from '../apis/login'
import menu from '@/apis/SystemSetting'

export default {
  data() {
    return {
      week: 1,
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      dateTime: '',
      navid: 0,
      navlist: [
        { id: 0, indexData: 0,name: '首页', path: '/home' },
        { id: 1, indexData: 1,name: '企业简介', path: '/companyprofile' },
        { id: 2, indexData: 2,name: '能源管理', path: '/energymanagement' },
        { id: 3, indexData: 3,name: '安全管理', path: '/securitymanagement' },
        { id: 4, indexData: 4,name: '设备管理', path: '/devicemanagement' },
        { id: 5, indexData: 5,name: '生产系统', path: '/productionsystem' },
        { id: 6, indexData: 6,name: '销售系统', path: '/salessystem' },
        { id: 7, indexData: 7,name: '物流系统', path: '/iogisticssystem' },
        { id: 8, indexData: 8,name: '系统配置', path: '/system' },
      ],
      qyxx:{
        logo: require('../assets/images/logo.png'),
        sysName:'德阳指尖秘码科技信息化系统',
        companyName:'创能云'
      },


    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        for (const item of this.navlist) {
          if (this.$route.path.search(item.path) !== -1) {
            this.navid = item.indexData
          }
        }
      },
    },
  },
  methods: {
    routerPath(index, path) {
      this.navid = index
      this.$router.push(path)
    },

    getDate() {
      //获取当前时间
      this.week = new Date().getDay()
      //格式化为本地时间格式
      this.dateTime =  new Date().Format("yyyy/MM/dd hh:mm:ss")

    },
    loginOut() {
      this.$confirm('确认退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        api.loginOut().then(() => {
          localStorage.clear()
          location.replace('/')
        })
      })
    },
  },
  mounted() {
    setInterval(() => {
      this.getDate()
    }, 1000)

    api.qyjj().then((res) => {
      if (res.code === 10000) {
        if (res.data) {
          this.qyxx = res.data
        }
      } else {
        this.$message.error(res.message)
      }
      this.load = true
    })

    menu.list({
      params: {
        hidden: 1,
      },
    })
    .then((res) => {
      if (res.code === 10000) {

        if (res.data.length) {
          this.navlist = res.data
          this.navlist.push(
            { id: 10,indexData:10, name: '系统配置', path: '/system' },
          )
          
          for (const item of this.navlist) {
            if (this.$route.path.search(item.path) !== -1) {
              this.navid = item.indexData
            }
          }



        }
      } else {
        this.$message.error(res.message)
      }
    })



  },
}
</script>

<style lang="less" scoped>
.page {
  height: 100%; 
  width: 100%; margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.header {
  height:5.0rem;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: url(../assets/images/new/bg_top.png) center bottom no-repeat;
  background-size: contain;
  .left {
    font-size: 1.4rem;
    font-weight: bold;
    color: #00ccff;
    position: absolute;
    top: 2rem;
    left: 1rem;
    font-family: '黑体';
    img {
      display: inline-block;
      width: 2.2rem;
      height: 2.2rem;
      // box-shadow: 0 0 5px #ccd0f2;
      // border-radius: 50%;
      overflow: hidden;
      margin-right: 0.45rem;
      vertical-align: middle;
      position: relative;
      top: -4px;
    }
  }
  .right {
    font-size: 0.75rem;
    cursor: pointer;
    position: absolute;
    top: 1.25rem;
    right: 0.68rem;
    text-align: center;
    color: #a0dbf5;
  }
  .nav {
    width:114rem;
    overflow: hidden;
    position: relative;
    top: 2rem;
    margin: 0 auto;
    li {
      font-size: 1rem;
      line-height: 2rem;
      text-align: center;
      cursor: pointer;
      width: 6.4rem;
      height:2rem;
      transition: all 0.5s ease 0s;
      background: url(../assets/images/new/bg_nav.png) no-repeat center;
      background-size: contain;
      color: #a0dbf5;
       float: left;
    }
    li:nth-child(1) {
      margin-left: 12.8rem;
    }
    li:nth-child(5) {
      margin-left: 37.6rem;
    }
    li:hover {
      color: #fff;
    }
    li.active {
      color: #fff;
      background-image: url(../assets/images/new/bg_nav_active.png)
    }
  }
  .canvars {
    perspective: 31.25rem;
    width: 36rem;
    position: absolute;
    top: -6px;
    left: 50%;
    margin-left: -18rem;
    .title {
      height: 4.5rem;
      line-height: 4.5rem;
      text-align: center;
      color: #a0dbf5;
      font-size:1.47rem;
      font-weight: bold;
      font-family: '黑体';
      text-shadow: 0 1px 1px rgb(0, 0, 0);
      letter-spacing: 4px;
    }
  }
}
</style>